import * as i from "../../../contracts";

export const mapHasLiveEvents = (league: i.League) => {
    league.hasLiveEvents = (league.liveFixturesTotalCount && league.liveFixturesTotalCount > 0) || (league.liveOutrightsTotalCount && league.liveOutrightsTotalCount > 0) || false;
}
